module.exports = __webpack_public_path__ + "static/media/tt_norms_extrabold.2e235bc8.otf";